import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
export default function OneStopBox({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4230_3095)">
        <path
          d="M24.0739 30.6483L24.0739 30.6483L38.6051 28.0751L43.9261 33.3517L29.3949 35.9249L24.0739 30.6483Z"
          stroke={fillPrimary}
          strokeWidth="2"
        />
        <path
          d="M23.9261 30.6483L23.9261 30.6483L9.39489 28.0751L4.07392 33.3517L18.6051 35.9249L23.9261 30.6483Z"
          stroke={fillPrimary}
          strokeWidth="2"
        />
        <path
          d="M9 34.9286V43.3829C9 43.8648 9.34364 44.2781 9.81741 44.3661L23.087 46.8304C23.6905 46.9425 24.3095 46.9425 24.913 46.8304L38.1826 44.3661C38.6564 44.2781 39 43.8648 39 43.3829V34"
          stroke={fillPrimary}
          strokeWidth="2"
        />
        <rect x="23" y="32" width="2" height="15" fill={fillPrimary} />
        <rect
          x="1.75879"
          y="12.1309"
          width="10.2768"
          height="12.2496"
          rx="1"
          transform="rotate(-13.3497 1.75879 12.1309)"
          stroke={fillSecondary}
          strokeWidth="2"
        />
        <path
          d="M1.96046 12.9811C1.86826 12.5926 2.01605 12.1865 2.33639 11.948L9.76255 6.42099C10.3439 5.98835 11.178 6.29833 11.3356 7.0056L14.3837 20.6783C14.5027 21.2121 14.1708 21.7425 13.6386 21.8688L5.55268 23.7877C5.01532 23.9152 4.47633 23.5829 4.34881 23.0456L1.96046 12.9811Z"
          stroke={fillSecondary}
          strokeWidth="2"
        />
        <path
          d="M6.55664 17.2178L9.04165 16.6281"
          stroke={fillSecondary}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6.00024 14.8733L9.31358 14.087"
          stroke={fillSecondary}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M9.59766 18.9722L7.11265 19.5619"
          stroke={fillSecondary}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M34.9699 9.67246L33.9418 14.3188C33.6168 15.7875 33.7075 17.3119 34.2019 18.6912C34.6963 20.0705 35.5712 21.2399 36.7113 22.0453L37.2397 22.4182C37.5916 22.6668 38.021 22.7618 38.4449 22.6849L39.0814 22.5697C40.4548 22.3205 41.7414 21.6294 42.7715 20.5874C43.8017 19.5454 44.5271 18.2016 44.852 16.733L45.8802 12.0866C45.9199 11.912 45.9126 11.7305 45.8591 11.564C45.8055 11.3975 45.7081 11.253 45.5784 11.148C44.1768 10.0555 42.5666 9.30417 40.8535 8.94324C39.1479 8.54771 37.3712 8.5496 35.6394 8.94877C35.4776 8.9893 35.3283 9.07916 35.2095 9.20755C35.0907 9.33593 35.0075 9.49738 34.9699 9.67246Z"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="36.1259"
          y1="9.19359"
          x2="43.1259"
          y2="20.1936"
          stroke={fillSecondary}
          strokeWidth="2"
        />
        <path
          d="M23.5464 25.5L26.1253 12.321C27.1287 12.1431 28.0523 11.6586 28.769 10.9341C29.4857 10.2097 29.9602 9.28088 30.1273 8.27561C30.2944 7.27033 30.1458 6.23798 29.7019 5.32066C29.2581 4.40333 28.5408 3.64611 27.6489 3.15323L27.2935 5.31041C27.2581 5.52317 27.1812 5.72688 27.0671 5.90991C26.953 6.09295 26.804 6.25172 26.6286 6.37716C25.9575 6.85694 25.2032 6.47517 24.4567 6.35635C24.0568 6.29269 23.7108 6.0387 23.4741 5.70769C23.2208 5.35335 23.1186 4.91289 23.19 4.4832L23.547 2.33018C22.5446 2.50919 21.6222 2.99427 20.9067 3.71874C20.1911 4.44322 19.7175 5.37152 19.5509 6.37608C19.3843 7.38064 19.5329 8.41214 19.9762 9.32883C20.4196 10.2455 21.136 11.0024 22.027 11.4954L19.1855 24.7112"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4230_3095">
          <rect width="48" height="48" fill={fillPrimary} />
        </clipPath>
      </defs>
    </svg>
  );
}
